import PropTypes from "prop-types";
import Reveal from "../Reveal/Reveal";
import "./SectionHeader.scss";

const SectionHeader = ({
  eyebrow,
  title,
  description,
  action,
  as: Heading = "h2",
  align = "start",
  id,
}) => (
  <Reveal className={`section-header section-header--${align}`}>
    <div className="section-header__text">
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <Heading className="section-header__title" id={id}>
        {title}
      </Heading>
      {description && <p className="section-header__desc">{description}</p>}
    </div>
    {action && <div className="section-header__action">{action}</div>}
  </Reveal>
);

SectionHeader.propTypes = {
  eyebrow: PropTypes.node,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  action: PropTypes.node,
  as: PropTypes.oneOf(["h1", "h2", "h3"]),
  align: PropTypes.oneOf(["start", "center"]),
  id: PropTypes.string,
};

export default SectionHeader;
